<!-- karkustom  & heritage & texas-->
<ng-container  *ngIf=" !chTheme2 && !chTheme3 && !chTheme4 && !chTheme9 && !chTheme10 && !chTheme12">
<button class="btn watch-shopbtn d-flex  align-items-center" [class.vehicle-selected]="vehicleName"  [ngClass]="themeClass('shop-by-vehicle-section1')" (click)="openVechicleSearchPopup()"
    aria-label="Shop by vehicle">
    <span *ngIf="(!chTheme7 && !chTheme8) && !chTheme12 && !chTheme13 && !chTheme14 &&  !chTheme15 && !vehicleName " class="bg-white d-md-none text-danger rounded-circle red-mobarrow me-md-2">
        <img [src]="commonImagePath+'red-arrow.webp'" alt="arrow-red-color" loading="lazy">
    </span>
    <ng-container *ngIf="!vehicleName; else hasvehicleName">
        <span class="btn-text  ps-md-0 ps-2">{{shop_by_vehicle_name}}</span>
        <span  *ngIf="!chTheme6 && !chTheme7 && !chTheme8 && !chTheme12 && !chTheme13 && !chTheme14 && !chTheme15" class="bg-white  text-danger rounded-circle red-arrow ms-2" aria-hidden="true">
            <img [src]="commonImagePath + 'shopbyvehicle_red_arroww.webp'" alt="" class="arrow-img d-md-inline"
                loading="lazy">
        </span>
    </ng-container>
    <ng-template #hasvehicleName>
        <span class="btn-text ps-md-0 ps-2">{{ vehicleName }}</span>
        <span  *ngIf="!chTheme7 && !chTheme8 && !chTheme12 && !chTheme13 && !chTheme14  && !chTheme15" class="bg-white  text-danger rounded-circle cross-arrow ms-2" aria-hidden="true" (click)="clearVehicle($event)">
            <img [src]="commonImagePath + 'shopbyvehicle_redcross_arrow.webp'" alt="" class="cross-img  d-md-inline"
                loading="lazy">
        </span>
              <!-- heritage & old air icon -->
           <div   *ngIf="chTheme7 || chTheme8 || chTheme13 || chTheme14 || chTheme15" (click)="clearVehicle($event)" class="cross-icon-wrap  ms-2">
                <i class="fa fa-times" aria-hidden="true"></i>
           </div>
    </ng-template>
</button>
</ng-container>


<!-- KDS  -->
<ng-container  *ngIf="chTheme2">
<button class="btn watch-kds-btn d-flex align-items-center justify-content-around" (click)="openVechicleSearchPopup()"
        aria-label="Shop by vehicle" [ngClass]="themeClass('shop-by-vehicle-section1')">
   <img src="assets/images/kds/kds-shop-btn.png" class="img-fluid kds-car">
   <ng-container *ngIf="!vehicleName; else hasvehicleName">
        <span class="btn-k-text  ps-md-0 ps-2">{{shop_by_vehicle_name}}</span>
    </ng-container>
    <ng-template #hasvehicleName>
        <span class="btn-k-text ps-md-0 ps-2">{{ vehicleName }}</span>
        <span class="bg-white d-none  d-md-inline text-danger rounded-circle red-arrow ms-2" aria-hidden="true">
            <img [src]="commonImagePath + 'shopbyvehicle_red_arrow.webp'" alt="" class=" d-md-inline"
                loading="lazy">
        </span>
    </ng-template>
</button>
</ng-container>


<!-- US-CHIP-TUNNING -->
<ng-container *ngIf="chTheme4 || chTheme10">
    <ng-container *ngIf="!vehicleName; else hasvehicleName">
        <button class="btn watch-chip-btn d-flex align-items-center justify-content-around chip-vehicle"
            (click)="openVechicleSearchPopup()" aria-label="Shop by vehicle">
            <span class="btn-us-text  ps-md-0 ps-2">{{shop_by_vehicle_name}}</span>
        </button>
    </ng-container>
    <ng-template #hasvehicleName>
        <button [class.vehicle-selected]="vehicleName" class="btn watch-chip-btn d-flex align-items-center justify-content-center gap-2">
            <span class="btn-us-text  vehicle-name ps-md-0 ps-2">{{ vehicleName }}</span>
            <span class=" d-none  d-md-inline  rounded-circle red-chip-arrow ms-3"
                (click)="clearVehicle($event)" aria-hidden="true">
                <!-- <img [src]="commonImagePath +'close_btn_sidebar.webp'" class="img-fluid"> -->
                 <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </button>
    </ng-template>
</ng-container>



<!-- TOWN-HUAL -->
<ng-container  *ngIf="chTheme3 || chTheme9 || chTheme12">
<button class="btn watch-hual d-flex align-items-center"   [class.vehicle-selected]="vehicleName"  [ngClass]="themeClass('shop-by-vehicle-section2')"[class.wish-btn]="isWishlist" (click)="openVechicleSearchPopup()"
    aria-label="Shop by vehicle"> 
    <ng-container *ngIf="!vehicleName; else hasvehicleName">
        <span class="btn-text  ps-md-0 ps-2">{{shop_by_vehicle_name}}
             <i *ngIf="!chTheme9 && !chTheme12" class="fa fa-angle-right "></i></span>
    </ng-container>
    <ng-template #hasvehicleName>
        <span class="btn-text ps-md-0 ps-2">{{ vehicleName }}</span>
        <div *ngIf="chTheme3 || chTheme9 || chTheme12" (click)="clearVehicle($event)" class="cross-icon-wrap  ms-2">
            <i class="fa fa-times" aria-hidden="true"></i>
        </div>
    </ng-template>
</button>
</ng-container>